import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useGames } from '../../context/GamesContext';

export default function GameFrame() {
  const { gameId } = useParams();
  const navigate = useNavigate();
  
  // Resolve o player usando o catálogo carregado da bucket
  const { games, loading, error, retry } = useGames();
  const game = games.find(item => item.id === gameId);
  const buildUrl = game?.isLaunched ? game.buildUrl : '';

  if (loading) return <p role="status">Carregando jogo...</p>;
  if (error) return <div role="alert"><p>{error}</p><button onClick={retry}>Tentar novamente</button></div>;

  if (!buildUrl) {
    return (
      <div style={{ color: 'white', textAlign: 'center', marginTop: '50px' }}>
        <h2>Jogo não encontrado ou ainda não lançado.</h2>
        <button onClick={() => navigate('/games')} style={{ padding: '10px 20px', cursor: 'pointer' }}>
          Voltar para Jogos
        </button>
      </div>
    );
  }

  return (
    <div style={{ width: '100%', height: '100vh', background: '#000', position: 'relative' }}>
      {/* Botão de Fechar/Voltar Flutuante */}
      <button 
        onClick={() => navigate('/games')}
        style={{
          position: 'absolute',
          top: '20px',
          left: '20px',
          zIndex: 1000,
          background: 'rgba(0,0,0,0.7)',
          color: 'white',
          border: '1px solid white',
          padding: '8px 16px',
          borderRadius: '4px',
          cursor: 'pointer',
          fontWeight: 'bold'
        }}
      >
        ← Voltar
      </button>

      <iframe
        src={buildUrl}
        title={`Game: ${gameId}`}
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          display: 'block'
        }}
        allow="autoplay; fullscreen; microphone"
        allowFullScreen
      />
    </div>
  );
}
